module.exports = __webpack_public_path__ + "img/100mrtx200.97acaf22.png";